import './index.scss'
import { observer } from 'mobx-react-lite'
import XImg from '@assets/svg/x.svg'
import { Context } from '@/index'
import { useContext } from 'react'
import FailedImg from '@assets/svg/failed.svg';

const DepositDeclinedModal = observer(({transactionId = ''}) => {
    const { modal } = useContext(Context);

    return (
        <div className="deposit-declined-modal">
            <div className="header-modal">
Əməliyyatın statusu
                <div className="x-block" onClick={() => modal.closeModal()}>
                    <img src={XImg} className="x" alt="close"/>
                </div>
            </div>
            <form className="form">
                <div className="status-icon">
                    <img src={FailedImg} alt="failed" />
                </div>
                <h1 className="status-title">
Ödəniş xətası
                </h1>
                <h5 className="status-subtitle">
Tranzaksiya <span className="transaction-id-bold">{transactionId && `№${transactionId}`}</span> bank tərəfindən rədd edildi. Zəhmət olmasa yenidən cəhd edin. Xətanın təkrarlanması halında - kartı silin və məlumatların düzgünlüyünü yoxlayaraq yenidən əlavə edin. Əgər xəta aradan qaldırılmasa - kartı buraxan banka müraciət edin.
                </h5>
                <div className="actions">
                    <button type='button' className="confirm" onClick={() => modal.closeModal()}>
Bağla
                    </button>
                </div>
            </form>
        </div>
    )
})

export { DepositDeclinedModal }